import React, { useState } from 'react';
import ReactTable, { ReactTableDefaults } from 'react-table-6';
import { CSVLink } from 'react-csv';
import { MdSync } from 'react-icons/md';
import { Order } from 'types/orderTypes';
import '../../styles/4-components/_react-table.scss';
import './OrderListTable.scss';
import 'react-table-6/react-table.css';
import { useTableHeight } from '../../hooks/useTableHeight';
import { ReqEnum } from '../../const/requestStatus';
import { reactTableToDataDownload } from './utils/reactTableToDataDownload';
import { BillingCompanyColumns } from './Columns/billingCompanyColumnsOld';
import { ButtonComponent } from '../../ReusableComponents/Button/ButtonComponent';

const tableWrapper: any = React.createRef();
let reactTable: any = React.createRef();
let csvLink: any = React.createRef();

export function OrderListTable({
  orders,
  fetchStatus = ReqEnum.INIT,
}: {
  orders: Order[];
  fetchStatus: ReqEnum;
}) {
  const columns: any = BillingCompanyColumns();

  const [tableHeight] = useTableHeight(tableWrapper);

  const [dataToDownload, setDataToDownload] = useState([]);

  const pagination = orders.length >= 100;

  function DownloadCSV() {
    const runDownload = async columns => {
      const data = reactTableToDataDownload(reactTable, columns);
      await setDataToDownload(data);
      if (data.length) {
        // click the CSVLink component to trigger the CSV download
        csvLink.link.click();
      }
    };

    return (
      <div className="orderlisttable__header__buttons u-screen-only">
        <ButtonComponent onClick={() => runDownload(columns)}>
          Download CSV
        </ButtonComponent>
        <CSVLink
          data={dataToDownload}
          filename="data.csv"
          className="hidden"
          ref={r => (csvLink = r)}
          target="_blank"
        />
      </div>
    );
  }

  return (
    <div
      className={
        fetchStatus === ReqEnum.PENDING
          ? 'orderlisttable is-loading'
          : 'orderlisttable'
      }
    >
      <div className="orderlisttable__header">
        <div className="orderlisttable__header__totals">
          <p>
            <em>Antall ordre:</em> <span>{orders.length}</span>
          </p>
        </div>

        <DownloadCSV />
      </div>
      <div
        ref={tableWrapper}
        className="u-print-height-auto"
        style={{
          height: tableHeight,
        }}
      >
        <ReactTable
          ref={r => (reactTable = r)}
          data={orders}
          resizable={true}
          pageSize={pagination ? 100 : orders.length}
          showPagination={pagination}
          className="-striped -highlight"
          previousText="Forrige"
          nextText="Neste"
          loadingText="Henter ordre..."
          noDataText="Fant ingen ordre"
          pageText="Side"
          ofText="av"
          rowsText="ordre"
          // pageJumpText="gå til side"
          // rowsSelectorText="ordre per side"
          column={{
            ...ReactTableDefaults.column,
            minWidth: 0,
          }}
          columns={columns}
          defaultFilterMethod={(filter, row) =>
            String(row[filter.id]) === filter.value
          }
          filterable
        >
          {(state, makeTable, instance) => {
            let recordsInfoText = '';

            const { filtered, pageRows, pageSize, sortedData, page } = state;

            if (sortedData && sortedData.length > 0) {
              const isFiltered = filtered.length > 0;

              const totalRecords = sortedData.length;

              const recordsCountFrom = page * pageSize + 1;

              const recordsCountTo = recordsCountFrom + pageRows.length - 1;

              if (isFiltered)
                recordsInfoText = `${recordsCountFrom}-${recordsCountTo} of ${totalRecords} filtered records`;
              else
                recordsInfoText = `${recordsCountFrom}-${recordsCountTo} of ${totalRecords} records`;
            } else recordsInfoText = 'No records';

            return (
              <div className="main-grid">
                <div className="above-table text-right">
                  <div className="col-sm-12">
                    <span className="records-info">{recordsInfoText}</span>
                  </div>
                </div>

                {makeTable()}
              </div>
            );
          }}
        </ReactTable>
      </div>
      <div className="orderlisttable__spinner">
        <MdSync />
      </div>
    </div>
  );
}
